export var isRightClick = function isRightClick(eventArgs) {
  return eventArgs.nativeEvent && eventArgs.nativeEvent.which === 3;
};
//# sourceMappingURL=isRightClick.js.map
